export type DistributionFormRow = {
  artifactName: string;
  versionName: string;
  packageType: string;
  distributed: boolean;
  isSupported: boolean;
  /** Server-built download/pull URL (docker pull command or generic URL). */
  distributionUrl?: string | null;
};

export type OpenArtifactDistributionDialogParams = {
  artifactName: string;
  versionName: string;
  packageType: string;
};

export type OpenReleaseDistributionDialogParams = {
  releaseId: string;
  repoName: string;
  repoOwner: string;
  workflowName: string;
  workflowRunNumber: string;
};

export function distributionRowKey(row: {
  artifactName: string;
  versionName: string;
  packageType: string;
}) {
  return `${row.artifactName}\0${row.versionName}\0${row.packageType}`;
}
